<template>
  <div class="loader">
    <img class="img-icones" :src="currentImagePath">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: "LoadingImgs",
  data() {
    return {
      images: [
        "/img/iconesCarregamento/leilao.png",
        "/img/iconesCarregamento/carro.png",
        "/img/iconesCarregamento/moto-grande-silhueta-negra.png",
        "/img/iconesCarregamento/predio.png",
        "/img/iconesCarregamento/barco-a-vela.png",
        "/img/iconesCarregamento/trator.png",
        "/img/iconesCarregamento/casa-de-fazenda.png",
        "/img/iconesCarregamento/chave-de-casa.png",
        "/img/iconesCarregamento/lancha.png",
        "/img/iconesCarregamento/ceifeira-debulhadora.png",
      ],
      currentImage: 0
    }
  },
  computed: {
    currentImagePath() {
      return require(`../../assets${this.images[this.currentImage]}`);
    }
  },
  mounted() {
    setInterval(() => {
      this.currentImage = (this.currentImage + 1) % this.images.length;
    }, 500);
  }
}
</script>

<style scoped>
.spinner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-left-color: #032c35;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  animation: spin 1s linear infinite;
}
.loader {
  height: 100vh;
  position: fixed;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  z-index: 999999;
  background: white;
}

.img-icones {
  position: absolute;
  width: 32px;
  height: 32px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>